/**
 * This is a direct port from FES. To make sure that the styles are the same, we are using the same
 * styles as in FES with some minor changes to make it work with our new theming setup.
 */
import styled from 'styled-components'

import { ImageCustom } from '@/components/shared/image'

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.purple.light5};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.grey.light1};
  color: ${({ theme }) => theme.colors.grey.primary};
  display: block;
  padding: ${({ theme }) => `${theme.spacing.default} ${theme.spacing.defaultSmall}`};
  position: relative;
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
`

// eslint-disable-next-line @kijiji/prefer-button-component
export const CloseButton = styled.button`
  background: transparent;
  border: none;
  padding: ${({ theme }) => theme.spacing.mini};
  margin-right: ${({ theme }) => theme.spacing.defaultSmall};
  cursor: pointer;

  & svg {
    height: 2rem;
    width: 2rem;
  }
`

export const Logo = styled(ImageCustom)`
  width: 5.6rem;
  height: 5.6rem;
  margin-right: 1.1rem;
`

export const Info = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`

// eslint-disable-next-line @kijiji/prefer-button-component
export const LearnMoreButton = styled.button`
  display: flex;
  flex: 1;
  max-width: fit-content;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.blue.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: 1rem 1.3rem;
  margin: 0 1rem;
  text-transform: uppercase;
  text-decoration: none;
  border-radius: ${({ theme }) => theme.borderRadius.rounded};
  font-size: 1.3rem;

  &:hover {
    background-color: #0059b3;
  }
`
